module.exports = __webpack_public_path__ + "img/vip.500a5892.png";